import * as tslib_1 from "tslib";
import HeaderContainer from './HeaderContainer';
import StorageAccountsListView from './StorageAccountsListView';
import initializeStorageAccountsOption from '../actions/initializeStorageAccountsOption';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { FileProvidersToAddListView } from 'owa-filepicker-options-view';
import { lazyAddAndSelectFileProvider, lazyRemoveFileProvider } from 'owa-filepicker-store';
import { store as fileProviderStore } from 'owa-fileprovider-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import * as ReactDOM from 'react-dom';
import { AddStorageAccountCallout } from './AddStorageAccountCallout';
import { LightningId } from 'owa-lightning';
var styles = require('./StorageAccountsFull.scss');
var StorageAccountsFull = /** @class */ (function (_super) {
    tslib_1.__extends(StorageAccountsFull, _super);
    function StorageAccountsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addAndSelectFileProviderAction = null;
        // Keeps track of whether there is already an account removal action going on
        _this.isAccountBeingRemoved = {};
        _this.getAddStorageAccountFunc = function (account) {
            return function () {
                // If we already have the action loaded then just execute it
                // otherwise make an asynchronous call to load it and then call it
                // which will trigger the popup blocker but its the fallback logic.
                if (_this.addAndSelectFileProviderAction) {
                    _this.addAndSelectFileProviderAction(account.type);
                }
                else {
                    lazyAddAndSelectFileProvider.import().then(function (addAndSelectFileProvider) {
                        addAndSelectFileProvider(account.type);
                    });
                }
            };
        };
        _this.removeAccount = function (viewState) {
            var id = viewState.model.Id;
            if (!_this.isAccountBeingRemoved[id]) {
                // If there was no ongoing account removal action for the
                // corresponding account then initiate it. The reason we only
                // allow one removal action to be called at a time as otherwise
                // any other requests after the successful removal of account will fail
                // which might cause the removal failure dialog to open giving the impression
                // to user that removing the account failed.
                _this.isAccountBeingRemoved[id] = true;
                lazyRemoveFileProvider
                    .importAndExecute(viewState.model.Id)
                    .then(function () {
                    // Set the state back to false as the operation completed
                    _this.isAccountBeingRemoved[id] = false;
                })
                    .catch(function () {
                    /* Ignore any error */
                    // Set the state back to false as the operation completed
                    _this.isAccountBeingRemoved[id] = false;
                });
            }
        };
        return _this;
    }
    StorageAccountsFull.prototype.componentDidMount = function () {
        var _this = this;
        // Initialize the addAndSelectFileProvider so that by the time user clicks it
        // we don't have to import it asynchornously and execute as that can cause
        // popup blocker to trigger
        lazyAddAndSelectFileProvider.import().then(function (addAndSelectFileProvider) {
            _this.addAndSelectFileProviderAction = addAndSelectFileProvider;
        });
        initializeStorageAccountsOption();
    };
    StorageAccountsFull.prototype.render = function () {
        var target;
        var _a = this.props, addableFileProvidersViewState = _a.addableFileProvidersViewState, fileProvidersViewState = _a.fileProvidersViewState, areFileProvidersLoaded = _a.areFileProvidersLoaded;
        var _b = this.getStorageAccountCategories(fileProvidersViewState), primaryAccounts = _b.primaryAccounts, secondaryAccounts = _b.secondaryAccounts;
        var providersToAddInfo = this.getStorageAccountToAdd(addableFileProvidersViewState);
        return areFileProvidersLoaded ? (React.createElement("div", { className: styles.container },
            React.createElement("div", null,
                providersToAddInfo.length !== 0 && (React.createElement("div", null,
                    React.createElement(HeaderContainer, { className: styles.fileProvidersToAddContainer, ref: function (ref) { return (target = ReactDOM.findDOMNode(ref)); }, header: strings.options_storageAccounts_addAccountHeader },
                        React.createElement(FileProvidersToAddListView, { providersToAddInfo: providersToAddInfo })),
                    React.createElement(AddStorageAccountCallout, { lid: LightningId.AddStorageAccountCallout, when: function (lightup) { return setTimeout(lightup, 500); }, target: function () { return target; } }))),
                React.createElement(StorageAccountsListView, { header: strings.options_storageAccounts_primaryAccount, storageAccounts: primaryAccounts }),
                React.createElement(StorageAccountsListView, { header: strings.options_storageAccounts_otherAccounts, storageAccounts: secondaryAccounts, onRemoveHandler: this.removeAccount })))) : (React.createElement(Spinner, null));
    };
    StorageAccountsFull.prototype.getStorageAccountToAdd = function (accountsToAdd) {
        var _this = this;
        return accountsToAdd.map(function (account) {
            return {
                providerType: account.type,
                providerName: account.name,
                onClick: _this.getAddStorageAccountFunc(account),
            };
        });
    };
    StorageAccountsFull.prototype.getStorageAccountCategories = function (providers) {
        var _a = providers.filter(function (p) { return p.type !== 4 /* Mailbox */; }), primaryProvider = _a[0], secondaryProviders = _a.slice(1);
        return {
            primaryAccounts: primaryProvider ? [primaryProvider] : [],
            secondaryAccounts: secondaryProviders,
        };
    };
    StorageAccountsFull = tslib_1.__decorate([
        reactive({
            fileProvidersViewState: function () { return fileProviderStore.fileProvidersViewState; },
            addableFileProvidersViewState: function () { return fileProviderStore.addableFileProvidersViewState; },
            areFileProvidersLoaded: function () { return fileProviderStore.areFileProvidersLoaded; },
        })
    ], StorageAccountsFull);
    return StorageAccountsFull;
}(React.Component));
export default StorageAccountsFull;
//# sourceMappingURL=StorageAccountsFull.js.map